import { render, staticRenderFns } from "./PageCommunityList.vue?vue&type=template&id=07ce8ed6&scoped=true"
import script from "./PageCommunityList.vue?vue&type=script&lang=js"
export * from "./PageCommunityList.vue?vue&type=script&lang=js"
import style0 from "./PageCommunityList.vue?vue&type=style&index=0&id=07ce8ed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce8ed6",
  null
  
)

export default component.exports